export let markers = []
export let toMarker = null
export let fromMarkers = []
export let openRoute = false
export const viewportMarkers = []
export const setOpenRoute = state => openRoute = state
export const setToMarker = newToMarker => toMarker = newToMarker
export const setFromMarkers = newFromMarkers => fromMarkers = newFromMarkers
export const setMarkers = newMarkers => markers = newMarkers
export const clearViewportMarkers = () => viewportMarkers.splice(0, viewportMarkers.length)



// WEBPACK FOOTER //
// ./app/markers/index.js